import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import { Link, Redirect } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import { handleErrorMessage } from "../../../utils/functions";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../common/Button";
import {
  saveSkill,
  getSkills,
} from "../../../redux/actions/admin/skillActions";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

export default function SkillsStore() {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const skill = useSelector((state) => state.skillsReducers);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
    defaultValues: {
      name: "",
      skill_test: 0,
      description: "",
    },
  });

  useEffect(() => {
    if (!skill.loaded) dispatch(getSkills());
  }, [dispatch, skill.loaded]);

  const onSubmitData = (data) => {
    //se toma el valor del select para enviarlo a la tabla.. por defecto se le indicó que tomara el valor cero o (NO) del select
    dispatch(saveSkill(data));
  };

  return (
    <>
      {skill.redirect && <Redirect to="/skills/admin" />}
      <div className="mt-5 flex justify-end">
        <Link to="/skills/admin">
          <Button className="focus:outline-none" variant="outlined">
            <i className="fa fa-arrow-left mr-2"></i> {t("personal.back")}
          </Button>
        </Link>
      </div>
      <form className="w-1/2 mx-auto" onSubmit={handleSubmit(onSubmitData)}>
        <h1 className="text-xl lg:text-2xl font-semibold title-font text-gray-900">
          {t("skills.AddTitle")}
        </h1>
        <div className="w-full mx-2 my-5">
          <Controller
            name="name"
            id="name"
            control={control}
            rules={{
              required: {
                value: true,
                message: t("skills.error.skillname_required"),
              },
              pattern: {
                value: /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ:.,*#]{3,}$/,
                message: t("skills.error.skill_invalid"),
              },
            }}
            render={({ field }) => (
              <TextField
                type="text"
                id="name"
                name="name"
                label={t("skills.skill_name")}
                variant="outlined"
                className="w-full"
                error={errors.name ? true : false}
                helperText={t(handleErrorMessage(skill, "name"))}
                InputLabelProps={{
                  shrink: true,
                }}
                {...field}
              />
            )}
          />
          <ErrorMessage
            errors={errors}
            name="name"
            render={({ message }) => (
              <p className="mt-1 text-sm text-red-500">{message}</p>
            )}
          />
        </div>
        <div className="w-full mx-2 my-5">
          <Controller
            name="skill_test"
            id="skill_test"
            control={control}
            rules={{
              required: {
                value: true,
              },
            }}
            render={({ field }) => (
              <>
                <FormControl variant="outlined" className="w-full">
                  <InputLabel htmlFor="skill_test">
                    {t("skills.habilityTest")}
                  </InputLabel>
                  <Select
                    native
                    label={t("skills.habilityTest")}
                    inputProps={{
                      name: "skill_test",
                      id: "skill_test",
                    }}
                    disabled
                    {...field}
                  >
                    <option value="1">{t("vacancies.Yes")}</option>
                    <option value="0">{t("vacancies.n")}</option>
                  </Select>
                </FormControl>
              </>
            )}
          />
        </div>
        <div className="w-full mx-2 my-5">
          <Controller
            name="description"
            id="description"
            control={control}
            render={({ field }) => (
              <TextField
                type="text"
                multiline
                minRows={4}
                id="description"
                name="description"
                label={t("experience.description")}
                variant="outlined"
                className="w-full"
                error={errors.question ? true : false}
                helperText={t(handleErrorMessage(skill, "description"))}
                InputLabelProps={{
                  shrink: true,
                }}
                {...field}
              />
            )}
          />
          <ErrorMessage
            errors={errors}
            name="description"
            render={({ message }) => (
              <p className="mt-1 text-sm text-red-500">{message}</p>
            )}
          />
        </div>
        <div className="flex justify-center w-full mt-7">
          <CustomButton
            status={skill.button}
            text={t("experience.addbtn")}
            icon="fa fa-check"
          />
        </div>
      </form>
    </>
  );
}
